import { defineAsyncComponent } from "vue"

// Optimistic fallback rendered when a chunk is slow or fails to load (e.g. a cross-origin
// CDN/CORS block on a split CSS chunk). Frames it as still-fetching rather than a hard error,
// keeping a manual reload as the escape hatch. `label` names what's being fetched.
const fetchingFallback = (label) => ({
  functional: true,
  render: (h) =>
    h("div", { class: "text-center text-sm text-gray-500 py-8" }, [
      h("p", {}, label),
      h("p", { class: "mt-1" }, [
        "Taking a while? ",
        h(
          "a",
          {
            class: "underline",
            attrs: { href: "#" },
            on: {
              click: (event) => {
                event.preventDefault()
                window.location.reload()
              },
            },
          },
          "Reload the page",
        ),
      ]),
    ]),
})

// Wraps `defineAsyncComponent` with the fetching fallback so a failed dynamic import doesn't
// leave the Vue mount blank. We don't retry: a same-URL re-import is a no-op because the
// browser caches the failed module-map entry for the page's lifetime. Stale-deploy recovery
// (a one-shot reload) and PostHog reporting are handled globally in entrypoints/application.js.
export default function asyncComponent(loader, { label = "Loading…" } = {}) {
  return defineAsyncComponent({
    loader,
    errorComponent: fetchingFallback(label),
  })
}
